import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePost, UsePut} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import Form from "./Form";


const Edit = ({id}) => {


    const [plan, setPlan] = useState()
    const [errors, setErrors] = useState()
    const [isLoading, setIsLoading] = useState(true)


    const GetPlan = async () => {
        const response =  await UsePut(
            `/plans/get/${id}`,
            {data: {limit: 1, offset: 0, _id: id}}
        )
        return response?.entities[0]
    }


    useEffect(() => {
        GetPlan().then((response) => {
            setPlan(response)
            setIsLoading(false)
        })
    }, [])


    const handleUpdate = (PostData) => {
        setIsLoading(true)
        UsePost(
            `/plans/upsert/${id}`,
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    UseMessage('success', 'Plan has been successfully updated')
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form plan={plan} errors={errors} isReady={!isLoading} onSubmit={handleUpdate}/>
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Edit